
export default class RoomNavBar {

	static getHolderSelectors = () => ['.room-nav-bar-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this;
		document.querySelector('.room-nav-bar-position-holder').style.height = this.#holderElement.offsetHeight/16 + 'rem';

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(function (entries) {
				if (entries[0].isIntersecting) {
					document.querySelector('.room-nav-bar-position-holder').style.display = 'none';
					self.#holderElement.classList.remove('scrolled');
				} else {
					document.querySelector('.room-nav-bar-position-holder').style.display = 'block';
					self.#holderElement.classList.add('scrolled');
				}
			});
			if (document.querySelector('header')) {
				observer.observe(document.querySelector('header'));
			} else {
				document.querySelector('.room-nav-bar-position-holder').style.display = 'block';
				this.#holderElement.classList.add('scrolled');
			}
		}
	}

}
